import { Link } from "react-router-dom";
import { titles } from "@/mocks/titles";

const entries = [
  {
    type: "movie",
    label: "电影",
    en: "Movies",
    description: "从悬疑到科幻，按地区、年份与类型快速筛选你想看的那一部。",
    icon: "ri-film-line",
    tone: "primary",
  },
  {
    type: "tv",
    label: "电视剧",
    en: "TV Series",
    description: "短剧集与长剧集齐聚，追剧党可以从最新更新开始。",
    icon: "ri-tv-2-line",
    tone: "accent",
  },
];

export default function CategoryEntry() {
  return (
    <section className="relative z-20 -mt-10 w-full md:-mt-14">
      <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 gap-4 px-4 md:grid-cols-2 md:px-6">
        {entries.map((entry) => {
          const count = titles.filter((item) => item.type === entry.type).length;
          const isPrimary = entry.tone === "primary";
          return (
            <Link
              key={entry.type}
              to={`/category/${entry.type}`}
              className="group flex animate-fade-up items-center justify-between gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors duration-300 hover:border-accent-300 md:p-6"
            >
              <div className="flex items-center gap-4">
                <span
                  className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-md ${
                    isPrimary
                      ? "bg-primary-900 text-secondary-300"
                      : "bg-accent-500 text-primary-950"
                  }`}
                >
                  <i className={`${entry.icon} text-xl`} />
                </span>
                <div>
                  <p className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-950">
                    {entry.label}
                    <span className="font-label text-[10px] uppercase tracking-[0.18em] text-foreground-400">
                      {entry.en}
                    </span>
                  </p>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-500">
                    {entry.description}
                  </p>
                </div>
              </div>
              <div className="flex shrink-0 flex-col items-end gap-1">
                <span className="font-label text-xl font-semibold text-foreground-900">{count}</span>
                <span className="flex items-center gap-1 text-[11px] text-foreground-500 transition-colors duration-300 group-hover:text-accent-700">
                  进入
                  <i className="ri-arrow-right-up-line" />
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}